/* Panacea Palm meal-plan shared runtime */
(function(){
  if(window.__ppPlanShared) return; window.__ppPlanShared=true;
  function ppCartAdd(btn, variantId) {

    /* Step 1: Add item to cart */
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      /* Step 2: Use Shopify Section Rendering API to get fresh cart HTML */
      var sectionIds = [];
      document.querySelectorAll('[data-section-id]').forEach(function(el) {
        var id = el.getAttribute('data-section-id');
        if (id && (id.includes('cart') || id.includes('header'))) sectionIds.push(id);
      });

      /* Impulse cart drawer section IDs */
      var knownSections = 'cart-drawer';
      fetch('/?sections=' + knownSections)
        .then(function(r) { return r.json(); })
        .then(function(sections) {
          Object.keys(sections).forEach(function(sectionId) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(sections[sectionId], 'text/html');
            /* Find matching section on page and replace its innerHTML */
            var target = document.getElementById('shopify-section-' + sectionId);
            var source = doc.getElementById('shopify-section-' + sectionId);
            if (target && source) {
              target.innerHTML = source.innerHTML;
            }
          });
        })
        .catch(function() {})
        .finally(function() {
          /* Step 3: Open the cart drawer by clicking the header cart button */
          setTimeout(function() {
            var cartOpener = document.querySelector(
              '[data-js-cart-drawer-trigger], [data-cart-toggle], ' +
              '.site-header__icon--cart, .cart__toggle, ' +
              '[aria-label*="cart" i], [aria-label*="Cart" i]'
            );
            if (cartOpener) {
              cartOpener.click();
            } else {
              window.location.href = '/cart';
            }
          }, 150);
        });
    })
    .catch(function() {
      window.location.href = '/cart';
    });
  };

  window.ppSmoothScroll = function(e, id) {
    e.preventDefault();
    var target = document.getElementById(id);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };


  window.ppCartAdd=ppCartAdd;
  window.ppQuiz=function(){ try{ var d=JSON.parse(localStorage.getItem('ppq_result')||'null'); if(d&&d.r&&d.r.target) return d; }catch(e){} return null; };
  window.ppBuyWithQuiz=function(btn,variantId){
    var q=window.ppQuiz();
    if(!q){ ppCartAdd(btn,variantId); return; }
    var attrs={ 'Calorie target': String(q.r.target), 'Quiz': JSON.stringify({g:q.a.goal,i:q.a.intensity,s:q.a.sex,a:q.a.age,h:q.a.height,w:q.a.weight,act:q.a.activity,u:q.units}) };
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:attrs})})
      .then(function(){ ppCartAdd(btn,variantId); })
      .catch(function(){ ppCartAdd(btn,variantId); });
  };
  var ro=new IntersectionObserver(function(entries){
    entries.forEach(function(entry,i){
      if(entry.isIntersecting){ entry.target.style.transitionDelay=(i*0.08)+'s'; entry.target.classList.add('pp-visible'); ro.unobserve(entry.target); }
    });
  },{threshold:0.12});
  function watch(){ document.querySelectorAll('.pp-mealplan .pp-reveal:not(.pp-visible)').forEach(function(el){ro.observe(el);}); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',watch); else watch();
})();
